module.exports = __webpack_public_path__ + "static/media/Icon awesome-facebook-f.598ef73f.svg";